import AccordionSection from './AccordionSection';

export default AccordionSection;
